module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Hook",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', {
    staticClass: "C_Current__And__No_Italic"
  }, [_vm._v("With his thick, unruly, chestnut hair, golden eyes, tall, trim frame, and playboy persona, Charles Macquarrie was exactly the sort of man Jon daydreamed about—")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RgdRt"
  }, [_vm._v("in the rare moments he allowed himself to dream. Mr. Macquarrie was the kind of man he wanted to be someday and the kind of man he wanted with fierce longing. He wasn’t sure if this was a good thing or a bad thing, but there was nothing he could do to change it. He’d just have to mind his peas and cues as Sister Grace liked to say. Jon had no idea what peas had to do with cues, but he knew he’d have to be on his best behavior when he met Mr. Macquarrie. He couldn’t be mooning over him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RgdRt"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RgdRt"
  }, [_vm._v("After looking at a few more pictures, Jon logged off and went to bed. His last thought before sleep was a fervent prayer that he wouldn’t do or say anything foolish in front of the very attractive man he was going to be working for.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0